import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { IApiResponse, IPaymentKeyDto, IPaymentModeDto } from '../models';

@Injectable()
export class PaymentService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getPaymentKeys(id: number): Observable<IPaymentKeyDto> {
    return this.get(`admin/payment/keys/${id}`);
  }

  public updatePaymentKeys(
    id: number,
    model: IPaymentKeyDto
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/payment/keys/${id}`, model);
  }

  public getPaymentModes(id: number): Observable<IPaymentModeDto[]> {
    return this.get(`admin/payment/modes/${id}`);
  }

  public validateSquareUp(id: number): Observable<boolean> {
    return this.get(`admin/payment/square/${id}`);
  }

  public updatePaymentModes(
    id: number,
    model: IPaymentModeDto[]
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/payment/modes/${id}`, model);
  }
}
